var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: [_vm.bemBlock], style: _vm.cssCustomProps }, [
        _c("p", { class: [_vm.bemElement("title")] }, [
          _vm._v("\n    " + _vm._s(_vm.filterDisplayName) + "\n  ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: [_vm.bemElement("content")] },
          [
            _vm._t(
              "default",
              _vm._l(_vm.options, function(option, index) {
                return _c(
                  "button",
                  {
                    key: index,
                    class: [
                      _vm.bemElement("option", {
                        selected: _vm.isOptionSelected(option),
                        "col-break": option.isFirstNumber
                      }),
                      "btn",
                      "btn--secondary",
                      "interaction--enabled-hover-v1"
                    ],
                    attrs: { disabled: _vm.disabled },
                    on: {
                      click: function($event) {
                        return _vm.handleOptionClick($event, option)
                      }
                    }
                  },
                  [
                    _vm._t(
                      "optionContent",
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(option.displayValue) +
                            "\n        "
                        )
                      ],
                      { option: option }
                    )
                  ],
                  2
                )
              }),
              { options: _vm.options }
            ),
            _vm._v(" "),
            _vm._t("content")
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }